import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const SupplierTextCell = (props: GridCellProps) => {
  const { displayValue } = useGridCellDisplayValue(props);

  return <GridCellBase {...props}>{displayValue}</GridCellBase>;
};

export default SupplierTextCell;
